import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import ProfileSteps from './ProfileSteps';

const ProfileContainer = ({ t, children, currentStep }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('profile'),
      url: '/profile',
    },
    {
      label: t(currentStep),
      url: `/profile/${currentStep}`,
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <ProfileSteps currentStep={currentStep} />
          {children}
        </div>
      </div>
    </main>
  );
};

ProfileContainer.propTypes = {
  t: PropTypes.func,
  children: PropTypes.element,
  currentStep: PropTypes.string,
};

export default withTranslation('common')(ProfileContainer);
